import {gql} from 'apollo-angular';

export function retrievePmsByEmployeeId(fields: string[]) {
  return gql`
      query retrievePmsByEmployeeId($employeeId: String!,  $page: Int!, $size: Int!) {
          retrievePmsByEmployeeId(employeeId: $employeeId, page: $page, size: $size) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function retrievePmsByEmployeeIdAndStatuses(fields: string[]) {
  return gql`
      query retrievePmsByEmployeeIdAndStatuses($employeeId: String!, $statuses: [PmStatus]!) {
          retrievePmsByEmployeeIdAndStatuses(employeeId: $employeeId, statuses: $statuses) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function retrievePmById(fields: string[]) {
  return gql`
      query retrievePmById($id: String!) {
          retrievePmById(id: $id) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function createPm(fields: string[]) {
  return gql`
      mutation createPm($pm: ConceptPmDto!) {
          createPm(pm: $pm) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function updatePm(fields: string[]) {
  return gql`
      mutation updatePm($pm: PmDto!) {
          updatePm(pm: $pm) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function removePm() {
  return gql`
      mutation removePm($pmId: String!) {
          removePm(pmId: $pmId)
      }
  `;
}

export function retrievePmFeedback(fields: string[]) {
  return gql`
      query retrievePmFeedback($pmId: String!) {
          retrievePmFeedback(pmId: $pmId) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function createPmFeedback(fields: string[]) {
  return gql`
      mutation createPmFeedback($pmId: String!, $pmFeedback: PmFeedbackDto!) {
          createPmFeedback(pmId: $pmId, pmFeedback: $pmFeedback) {
              ${fields.join('\n')}
          }
      }
  `;
}

export function approvePm() {
  return gql`
      mutation approvePm($pmId: String!) {
          approvePm(pmId: $pmId)
      }
  `;
}

export function retrievePmStatusSummary(fields: string[]) {
  return gql`
      query retrievePmStatusSummary {
          retrievePmStatusSummary {
              ${fields.join('\n')}
          }
      }
  `;
}

export function submitPmFeedbackRequest() {
  return gql`
      mutation submitPmFeedbackRequest($pmId: String!, $feedbacks: [PmFeedbackDto!]!, $feedbackExpiryDate: Date!) {
          submitPmFeedbackRequest(pmId: $pmId, feedbacks: $feedbacks, feedbackExpiryDate: $feedbackExpiryDate)
      }
  `;
}

export function updatePmFeedbackExpiryDate() {
  return gql`
      mutation updatePmFeedbackExpiryDate($pmId: String!, $feedbackExpiryDate: Date!, $isSelfReflection: Boolean!) {
          updatePmFeedbackExpiryDate(pmId: $pmId, feedbackExpiryDate: $feedbackExpiryDate, isSelfReflection: $isSelfReflection)
      }
  `;
}
